

import React, { useState } from 'react'
import '../../css/comoLlegar.scss'
import MapaPichi from '../frames/MapaPichi'
import MapaTopo from '../frames/MapaTopo'
import MapaMaza from '../frames/MapaMaza'

import Footer from '../Footer'


export default function ComoLlegar() {

  const [mapaActivo, setMapaActivo] = useState('mapa1')


  return (
    <>
      <section className='como-llegar'>

  
        <div className='container'>

          <div className='como-llegar-grid'>

            {/* LEFT */}
            <div className='como-llegar-text'>

              <span className='como-tag'>
                Información de terminales
              </span>

              <h2>¿Cómo llegar al puerto?</h2>

              <p>
                Consulta rutas, accesos, estacionamientos y horarios
                para llegar al puerto con suficiente anticipación
                y sin contratiempos.
              </p>

              <div className='botones-mapa'>

                {/* PICHILINGUE */}
                <button
                  className={
                    mapaActivo === 'mapa1'
                      ? 'btn-mapa activo'
                      : 'btn-mapa'
                  }
                  onClick={() => setMapaActivo('mapa1')}
                >

                  <div className='btn-mapa-icon'>
                    <span className='material-symbols-outlined'>
                      <i class="fi fi-rs-map-marker"></i>
                    </span>
                  </div>

                  <div className='btn-mapa-content'>
                    <label>Puerto Pichilingue</label>

                    <p>
                      Interior Muelle de Altura API,
                      Lt. 1, Mzn. F, C.P. 23208,
                      La Paz, Baja California Sur.
                    </p>
                  </div>

                </button>

                {/* TOPO */}
                <button
                  className={
                    mapaActivo === 'mapa2'
                      ? 'btn-mapa activo'
                      : 'btn-mapa'
                  }
                  onClick={() => setMapaActivo('mapa2')}
                >

                  <div className='btn-mapa-icon'>
                    <span className='material-symbols-outlined'>
                      <i class="fi fi-rs-map-marker"></i>
                    </span>
                  </div>

                  <div className='btn-mapa-content'>
                    <label>Puerto Topolobampo</label>

                    <p>
                      Muelle de Transbordadores S/N,
                      Interior API,
                      Topolobampo, Sinaloa.
                    </p>
                  </div>

                </button>

                {/* MAZA */}
                <button
                  className={
                    mapaActivo === 'mapa3'
                      ? 'btn-mapa activo'
                      : 'btn-mapa'
                  }
                  onClick={() => setMapaActivo('mapa3')}
                >

                  <div className='btn-mapa-icon'>
                    <span className='material-symbols-outlined'>
                      <i class="fi fi-rs-map-marker"></i>
                    </span>
                  </div>

                  <div className='btn-mapa-content'>
                    <label>Puerto Mazatlán</label>

                    <p>
                      Ave. Emilio Barragán y Prol. Carnaval S/N,
                      Fracc. Playa Sur,
                      Mazatlán, Sinaloa.
                    </p>
                  </div>

                </button>

              </div>

            </div>

            {/* RIGHT */}
            <div className='como-llegar-right'>

              <div className='como-llegar-mapa'>

                {mapaActivo === 'mapa1' && <MapaPichi />}
                {mapaActivo === 'mapa2' && <MapaTopo />}
                {mapaActivo === 'mapa3' && <MapaMaza />}

                

              </div>

              

            </div>


          </div>
         
          {/* CONSIDERACIONES */}
        <div className='consideraciones-wrapper'>

          {/* LEFT */}
          <div className='consideraciones-box'>

            <h2>Consideraciones Importantes</h2>

            <div className='consideraciones-list'>

              <div className='consideracion-card'>
                <span className='material-symbols-outlined'>
                  <i class="fi fi-rs-tshirt"></i>
                </span>

                <p>
                  Todo línea blanca y electrónica nueva cargada en el vehículo
                  debe presentar factura; de lo contrario será decomisada.
                </p>
              </div>

              <div className='consideracion-card'>
                <span className='material-symbols-outlined'>
                  <i class="fi fi-rs-receipt"></i>
                </span>

                <p>
                  Todo línea blanca y electrónica usada cargada en el vehículo
                  será sujeto a gravamen del 19% del valor estimado.
                </p>
              </div>

              <div className='consideracion-card'>
                <span className='material-symbols-outlined'>
                  <i class="fi fi-rs-info"></i>
                </span>

                <p>
                  El puerto cobra $350 MXN por ATP y $35 MXN por control
                  y fumigación de plagas en carga y descarga.
                </p>
              </div>

            </div>

          </div>

          {/* RIGHT */}
          <div className='autoridades-box'>

            <h2>Autoridades</h2>

            <div className='autoridades-card'>

              <div className='autoridad-item'>
                <span>Mazatlán</span>
                <a href="https://www.puertomazatlan.com.mx/" target="_blank" rel="noopener noreferrer">
                  Asipona <i class="fi fi-rr-arrow-up-right-from-square"></i>
                </a>
              </div>

              <div className='autoridad-item'>
                <span>Topolobampo</span>
                <a href="https://www.puertotopolobampo.com.mx/" target="_blank" rel="noopener noreferrer">
                  Asipona <i class="fi fi-rr-arrow-up-right-from-square"></i>
                </a>
              </div>

              <div className='autoridad-item'>
                <span>Pichilingue</span>
                <a href="https://apibcs.com.mx/" target="_blank" rel="noopener noreferrer">
                  API BCS <i class="fi fi-rr-arrow-up-right-from-square"></i>
                </a>
              </div>

            </div>

          </div>

        </div>

        </div>

      </section>      

      <Footer />
    </>
  )
}